import { defaultArg, map, bind } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { ProductModule_ofInt } from "../../DomainTypes.js";
import { tryFind } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { optToStr, classNames, Locale$reflection, DateTimeOffsetExtensions_toDateHHmm } from "../../Utils.js";
import { DateTimeOffset_getDateStatus } from "../../DateUtils.js";
import { getStatusBall, Color } from "../../ViewUtils.js";
import * as react from "react";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, lambda_type, unit_type, list_type, option_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { NumberHistory$reflection } from "../Subscriptions/Common.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { getTranslationFrom } from "../../Global.js";
import { toText, printf } from "../../fable_modules/fable-library.3.7.20/String.js";
import { map as map_1, head, length as length_1, singleton, ofArray, fold } from "../../fable_modules/fable-library.3.7.20/List.js";
import { int32ToString, compareArrays } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { HTMLAttr, CSSProp } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { SelectOptionProps, SelectOptionProps_get_GetDefault, SelectOption } from "../../Components/StatefulFormFields/SelectOption.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import "../../../src/Containers/Telecom/Common.scss";


export function usesProvisioningViaSvea(networkIntegrationNr) {
    if (networkIntegrationNr != null) {
        const networkIntegrationNr_1 = networkIntegrationNr | 0;
        if (networkIntegrationNr_1 !== 2) {
            return networkIntegrationNr_1 !== 7;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export function getProductType(contracts, contractTypes, contractNr) {
    return bind((contract) => map((ct) => ProductModule_ofInt(ct.ProductNr), tryFind(contract.ContractTypeCode, contractTypes)), tryFind(contractNr, contracts));
}

export function toDisplayDate(locale, dto) {
    return DateTimeOffsetExtensions_toDateHHmm(locale, dto);
}

export function renderStatusBall(getTranslation, locale, nh) {
    let patternInput;
    const matchValue = nh.ActiveFrom;
    if (matchValue != null) {
        const activeFrom = matchValue;
        const matchValue_1 = DateTimeOffset_getDateStatus(activeFrom, nh.ActiveTo);
        switch (matchValue_1.tag) {
            case 2: {
                patternInput = [new Color(1), (getTranslation("Common.Activates") + " ") + DateTimeOffsetExtensions_toDateHHmm(locale, activeFrom)];
                break;
            }
            case 1: {
                patternInput = [new Color(1), (getTranslation("Common.Ends") + " ") + defaultArg(map((date) => DateTimeOffsetExtensions_toDateHHmm(locale, date), nh.ActiveTo), "?")];
                break;
            }
            case 0: {
                patternInput = [new Color(0), getTranslation("Common.Active")];
                break;
            }
            case 3: {
                patternInput = [new Color(2), getTranslation("Common.Inactive")];
                break;
            }
            default: {
                patternInput = [new Color(2), getTranslation("Common.Unknown")];
            }
        }
    }
    else {
        patternInput = [new Color(2), getTranslation("Common.Unknown")];
    }
    const children = [getStatusBall(patternInput[0], patternInput[1])];
    return react.createElement("span", {
        className: "d-flex align-items-center",
    }, ...children);
}

export class NumberMenuProps extends Record {
    constructor(SelectedNumberHistoryIndex, NumberHistories, Locale, ChangeNumberHistoryFn) {
        super();
        this.SelectedNumberHistoryIndex = SelectedNumberHistoryIndex;
        this.NumberHistories = NumberHistories;
        this.Locale = Locale;
        this.ChangeNumberHistoryFn = ChangeNumberHistoryFn;
    }
}

export function NumberMenuProps$reflection() {
    return record_type("Containers.Telecom.Common.NumberMenuProps", [], NumberMenuProps, () => [["SelectedNumberHistoryIndex", option_type(int32_type)], ["NumberHistories", list_type(NumberHistory$reflection())], ["Locale", Locale$reflection()], ["ChangeNumberHistoryFn", lambda_type(int32_type, unit_type)]]);
}

export const renderNumberMenu = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const numberToFromFormat_1 = printf("%s - %s");
    let getOptionHtml$0027;
    let phoneNumberCharWidth;
    const tupledArg = fold((state_1, nh_1) => {
        const numberFromToLength = (nh_1.NumberFrom !== nh_1.NumberTo) ? [nh_1.NumberFrom.length + nh_1.NumberTo.length, true] : [nh_1.NumberFrom.length, false];
        if (compareArrays(numberFromToLength, state_1) > 0) {
            return numberFromToLength;
        }
        else {
            return state_1;
        }
    }, [0, false], props.NumberHistories);
    const length = tupledArg[0] | 0;
    phoneNumberCharWidth = (tupledArg[1] ? (length + (numberToFromFormat_1.input.length - 4)) : length);
    const locale = props.Locale;
    getOptionHtml$0027 = ((nh) => {
        const activeFrom = defaultArg(map((dto) => toDisplayDate(locale.ILocale, dto), nh.ActiveFrom), "?");
        const activeTo = defaultArg(map((dto_1) => toDisplayDate(locale.ILocale, dto_1), nh.ActiveTo), getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.UntilFurtherNotice"));
        let activeBetween;
        const arg = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Active");
        activeBetween = toText(printf("%s: %s - %s"))(arg)(activeFrom)(activeTo);
        let numberFromToHtml;
        const patternInput = (nh.NumberFrom !== nh.NumberTo) ? [toText(numberToFromFormat_1)(nh.NumberFrom)(nh.NumberTo), true] : [nh.NumberFrom, false];
        const numberFromToClasses = classNames(ofArray([["number-menu__cell", true], ["number-menu__cell--disabled", patternInput[1]]]));
        numberFromToHtml = react.createElement("span", {
            className: numberFromToClasses,
        }, patternInput[0]);
        const statusBallHtml = renderStatusBall(getTranslation, locale.ILocale, nh);
        const dynamicGridStyle = singleton(new CSSProp(186, toText(printf("auto %ich auto auto"))(phoneNumberCharWidth)));
        let displayHtml;
        const props_5 = [new HTMLAttr(65, "number-menu__row"), ["style", keyValueList(dynamicGridStyle, 1)]];
        const children_4 = [statusBallHtml, numberFromToHtml, react.createElement("span", {
            className: "number-menu__cell",
        }, activeBetween)];
        displayHtml = react.createElement("div", keyValueList(props_5, 1), ...children_4);
        return [int32ToString(nh.Index), displayHtml];
    });
    const matchValue = length_1(props.NumberHistories) | 0;
    switch (matchValue) {
        case 0: {
            return react.createElement(react.Fragment, {});
        }
        case 1: {
            const children_7 = [getOptionHtml$0027(head(props.NumberHistories))[1]];
            return react.createElement("div", {
                className: "number-menu number-menu--single",
            }, ...children_7);
        }
        default: {
            const options = map_1(getOptionHtml$0027, props.NumberHistories);
            const children_9 = [SelectOption(new SelectOptionProps(optToStr(props.SelectedNumberHistoryIndex), options, (arg_5) => {
                props.ChangeNumberHistoryFn(parse(arg_5, 511, false, 32));
            }, SelectOptionProps_get_GetDefault().LabelText, 200))];
            return react.createElement("div", {
                className: "number-menu",
                ["data-regression"]: "telecom-select-number",
            }, ...children_9);
        }
    }
}, "NumberMenu", Helpers_equalsButFunctions, void 0, "renderNumberMenu", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\Common.fs", 169);

